(function () {
    'use strict';

    var pricePattern = /(?:\u20ac|\u00a3|\$)\s?\d[\d.,]*(?:\s?[A-Z]{3})?|\d[\d.,]*\s?(?:\u20ac|\u00a3|\$|EUR|USD|GBP)/g;
    var observer;
    var syncTimer;

    function isVisible(element) {
        if (!element || element.nodeType !== 1) return false;
        var style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && element.offsetParent !== null;
    }

    function getProductPriceBox() {
        return document.querySelector('.productView-price[id^="product-price-"]');
    }

    function getTextNodes() {
        var nodes = [];
        var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
            acceptNode: function (node) {
                var parent = node.parentElement;
                if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].indexOf(parent.tagName) !== -1) {
                    return NodeFilter.FILTER_REJECT;
                }

                return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            }
        });

        while (walker.nextNode()) nodes.push(walker.currentNode);

        return nodes;
    }

    function hasDealeasyBundle() {
        var text = document.body.innerText || '';
        return /Bundle and save|Add to bundle|View Selection|items added to the bundle|Total price/i.test(text);
    }

    function findTotalPriceLabelNode() {
        return getTextNodes().find(function (node) {
            return /Total price/i.test(node.nodeValue);
        });
    }

    function collectPricesAfterLabel(container) {
        var text = (container.textContent || '').replace(/\s+/g, ' ').trim();
        var labelIndex = text.search(/Total price/i);

        if (labelIndex === -1) return [];

        text = text.slice(labelIndex);

        var matches = text.match(pricePattern);
        return matches ? matches.map(function (price) {
            return price.trim();
        }) : [];
    }

    function getDealeasyPrices() {
        var labelNode = findTotalPriceLabelNode();
        if (!labelNode) return null;

        var current = labelNode.parentElement;

        for (var depth = 0; current && depth < 8; depth += 1) {
            if (!isVisible(current)) {
                current = current.parentElement;
                continue;
            }

            var prices = collectPricesAfterLabel(current);

            if (prices.length > 1) {
                return {
                    compare: prices[0],
                    total: prices[prices.length - 1]
                };
            }

            current = current.parentElement;
        }

        return null;
    }

    function renderSyncedPrice(priceBox, prices) {
        if (
            priceBox.getAttribute('data-dealeasy-total-price') === prices.total &&
            priceBox.getAttribute('data-dealeasy-compare-price') === prices.compare &&
            priceBox.style.display !== 'none'
        ) {
            return;
        }

        var compareHtml = prices.compare
            ? '<span class="price__compare price__compare--inline"><s class="price-item price-item--regular price-item--small">' + prices.compare + '</s></span>'
            : '';

        priceBox.innerHTML =
            '<div class="price price--medium price--on-sale dealeasy-synced-price">' +
                '<dl class="price__container">' +
                    '<div class="price__regular">' +
                        '<dd class="price__last"><span class="price-item price-item--regular">' + prices.total + '</span></dd>' +
                    '</div>' +
                    '<div class="price__sale show_saved_price">' +
                        '<dd class="price__last">' +
                            '<span class="price-item price-item--sale">' + prices.total + '</span>' +
                            compareHtml +
                        '</dd>' +
                    '</div>' +
                '</dl>' +
            '</div>';
        priceBox.style.display = '';
        priceBox.setAttribute('data-dealeasy-price-synced', 'true');
        priceBox.setAttribute('data-dealeasy-total-price', prices.total);
        priceBox.setAttribute('data-dealeasy-compare-price', prices.compare);
    }

    function syncDealeasyPrice() {
        var priceBox = getProductPriceBox();
        if (!priceBox || !hasDealeasyBundle()) return;

        var prices = getDealeasyPrices();

        if (!prices || !prices.compare || !prices.total || prices.compare === prices.total) {
            priceBox.style.display = 'none';
            priceBox.setAttribute('data-dealeasy-price-synced', 'hidden');
            return;
        }

        renderSyncedPrice(priceBox, prices);
    }

    function scheduleSync() {
        window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(syncDealeasyPrice, 120);
    }

    function init() {
        syncDealeasyPrice();

        observer = new MutationObserver(scheduleSync);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true
        });

        document.addEventListener('change', scheduleSync, true);
        document.addEventListener('click', scheduleSync, true);

        window.setTimeout(syncDealeasyPrice, 500);
        window.setTimeout(syncDealeasyPrice, 1500);
        window.setTimeout(syncDealeasyPrice, 3000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
